import { v4 as uuidv4 } from "uuid"
import md5 from "crypto-js/md5"

export function detectDRMPlatform(userAgent = "") {
  const ua = userAgent.toLowerCase()
  if (ua.includes("safari") && !ua.includes("chrome")) {
    return "fairplay"
  } else if (ua.includes("edge")) {
    return "playready"
  } else {
    return "widevine"
  }
}
export function maskPhoneNumber(name) {
  if (/^\d{9,}$/.test(name)) {
    return name.slice(0, -3) + "xxx"
  }
  return name
}

export function getSessionId() {
  let sessionId = sessionStorage.getItem("session_id")
  if (!sessionId) {
    sessionId = uuidv4()
    sessionStorage.setItem("session_id", sessionId)
  }
  return sessionId
}

export function getSessionSign(sessionId, secretKey) {
  const sign = md5(sessionId + secretKey).toString()
  return sign
}

export function renderUrl(base_url, thumbnail, size) {
  if (thumbnail?.includes("http")) return thumbnail
  if (!thumbnail) return "/placeholder_banner.svg"
  return `${base_url}${size}/${thumbnail}`
}
